export default __webpack_public_path__ + "static/custom-branding-80e24bbe3b5ea530a8361fff0a7b046f.svg";